<script setup lang="ts">
import { computed } from 'vue';
import { useAbility } from '@casl/vue';

import TablePageFooter from '@/components/footers/TablePageFooter.vue';
import ExportAsCsvIconBtn from '@/components/iconBtns/ExportAsCsvIconBtn.vue';
import BookedJobsSearchForm from '@/components/searchForms/BookedJobsSearchForm.vue';
import BookedJobsTable from '@/components/tables/BookedJobsTable.vue';
import FormWrapper from '@/components/wrappers/FormWrapper.vue';
import PageContentWrapper from '@/components/wrappers/PageContentWrapper.vue';
import TablePageShadowWrapper from '@/components/wrappers/TablePageShadowWrapper.vue';
import useDownloadCsv from '@/composables/useDownloadCsv';
import useBookedJobsView from '@/composables/views/useBookedJobsView';

import tabsStyles from '@/styles/tabs.module.scss';

const ability = useAbility();
const isStaff = computed(() => ability.can('staff', 'Job'));

const {
  view,
  initialData,
  isFetchingData,
  curPage,
  pageSize,
  total,
  tableTitle,
  results,
  resultsForCsv,
  search,
  setView,
} = useBookedJobsView();

const { isDownloadingCSV, downloadCsv } = useDownloadCsv();
</script>

<template>
  <div :class="$style.bookedJobBookingView" data-testid="bookedJobBookingView">
    <PageContentWrapper>
      <div :class="[$style.tabsWrapper, tabsStyles.tabsWrapper]">
        <v-tabs :class="tabsStyles.tabs" :model-value="view">
          <v-tab
            value="user"
            :ripple="false"
            :class="tabsStyles.tab"
            variant="plain"
            @click="setView('user')"
          >
            My jobs
          </v-tab>
          <v-tab
            value="customer"
            :ripple="false"
            :class="tabsStyles.tab"
            variant="plain"
            @click="setView('customer')"
          >
            My company jobs
          </v-tab>
        </v-tabs>
      </div>
      <FormWrapper :class="$style.formWrapper">
        <BookedJobsSearchForm
          :initial-data="initialData"
          :loading="isFetchingData"
          :is-staff="isStaff"
          :view="view"
          :class="$style.form"
          @submit="search"
        />
      </FormWrapper>
      <h2 class="g-h2">{{ tableTitle }} jobs</h2>
      <TablePageShadowWrapper :class="$style.tablePageShadowWrapper">
        <BookedJobsTable :data="results" :loading="isFetchingData" />
        <TablePageFooter
          v-if="total"
          :cur-page="curPage"
          :page-size="pageSize"
          :total="total"
        >
          <ExportAsCsvIconBtn
            :disabled="isFetchingData || !total"
            :loading="isDownloadingCSV"
            @click="downloadCsv(resultsForCsv, 'bookedJobs')"
          />
        </TablePageFooter>
      </TablePageShadowWrapper>
    </PageContentWrapper>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.bookedJobBookingView {
}
  .tabsWrapper {
    width: fit-content;
    margin: 0 1.5rem;
  }
  .formWrapper {
    width: fit-content;
    padding: 1.5rem 2rem 0.5rem 1.5rem;
    margin: 2rem 0;
  }
  .tablePageShadowWrapper {
    width: variables.$bookedJobsTableWidth;
  }
</style>
